<template lang="pug">
  div.stu-footer
    div
      p.fl.text-ct.stu-footer-info
        span.fl.f12.grey9
          a.f12.grey9(v-if="!isssproctor" href='http://beian.miit.gov.cn' target='_blank') {{ icp }}
          b.f12.grey9(v-else) {{ icp }}
        span.fl.f12.gong-an(v-if='icon')
          a.f12.grey9(v-if="!isssproctor" :href='"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=" + police' target='_blank' name='abc') 苏公网安备{{police}}号
          b.f12.grey9(v-else) 苏公网安备{{police}}号
      div.stu-footer-browser(v-if="!isssproctor")
        a.fl.f12.grey9(href='http://17ks.chivoxapp.com/guide/360Browse.exe') 
          img.fl(src='@/assets/image/common/icon_browser-360.png' alt='360')
          | {{$t('footer.browser360')}}
        a.fl.f12.grey9(href='http://17ks.chivoxapp.com/guide/QQBrowser.exe')
          img.fl(src='@/assets/image/common/icon_browser-qq.png' alt='QQ')
          | {{$t('footer.browserqq')}}
</template>

<script>
export default {
  name: 'Footer',
  data() {
    const { cfName } = window.ConfigNew.header
    const { copyright, icp, police, icon } = window.ConfigNew.footer
    const isssproctor = localStorage.getItem('isssproctor')
    return {
      cfName,
      copyright,
      icp,
      police,
      icon,
      isssproctor
    }
  }
}
</script>

<style>
@import './../../../static/styles/common/km-footer.css';
.gong-an {
  padding-left: 25px !important;
  margin-left: 5px;
  background: url('/static/images/abc.png') no-repeat left center;
}

.stu-footer-info b {
  height: 30px;
  line-height: 30px;
  color: #999;
  font-size: 12px;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/Stu/footer.vue